import { z } from 'zod';

const accountManagerSchema = z.object({
  id: z.number(),
  fullName: z.string(),
});

export const accountManagersResponse = z.object({
  accountManagers: z.array(accountManagerSchema),
});

export type AccountManager = z.infer<typeof accountManagerSchema>;
export type AccountManagersResponse = z.infer<typeof accountManagersResponse>;

export const podSchema = z.object({
  id: z.number(),
  name: z.string(),
});

export const podsResponse = z.array(podSchema);

export type Pod = z.infer<typeof podSchema>;
export type PodsResponse = z.infer<typeof podsResponse>;
